import React from 'react';
import { ListApplicationsTable } from './ListApplicationsTable';
import { User } from '../../../../../entities/User';
import { HrisEmployee } from '../../../../../entities/applicant_tracking/HrisEmployees';
import { HrisProvider } from '../../../../../enums/IntegrationProvider/HrisProvider';
import { AlertObject } from '../../../../../components/Alert';
import { EmailAccountIntegration } from '../../../../../entities/EmailAccountIntegration';
import { ListApplicationsFilters } from './ListApplicationsFilters';
import {
  ApplicationListingFilters,
  FilterType,
} from './ListApplicationsFilters/utils';
import { NewListCandidate } from '../../../../../entities/v1/applicant_tracking/NewListCandidate';

interface PropTypes {
  atsSignableOfferEnabled: boolean;
  atsTagsPanelEnabled: boolean;
  atsApplicationFormFilterEnabled: boolean;
  atsInterviewContentFilterEnabled: boolean;
  atsJobStatusFilterEnabled: boolean;
  candidates: NewListCandidate[];
  currentUser: User;
  emailAccountIntegration: EmailAccountIntegration;
  error: boolean;
  filterStates: ApplicationListingFilters;
  filterTypes: FilterType[];
  hrisEmployees?: HrisEmployee[];
  totalFilteredCandidates: number;
  selectedCandidates: NewListCandidate[];
  offerRequisitionFlowEnabled: boolean;
  hrisProvider?: HrisProvider;
  isLoading?: boolean;
  onSearch: () => void;
  setSelectedCandidates: (candidates: NewListCandidate[]) => void;
  setFilterTypes: (filterTypes: FilterType[]) => void;
  onFilterStatesUpdate: (fs: ApplicationListingFilters) => void;
  reloadPage: () => void;
  setAlert: (alert: AlertObject) => void;
}

export function ListApplicationsPageBody(props: PropTypes) {
  return (
    <div className='tab-content pb-1' id='candidates-table-tab-content'>
      <div
        className='tab-pane fade show active'
        id='candidates-all'
        role='tabpanel'
        aria-labelledby='candidates-all-tab'
      >
        <div className='app-card app-card-table shadow-sm mb-4'>
          <div className='app-card-body'>
            <ListApplicationsFilters
              atsTagsPanelEnabled={props.atsTagsPanelEnabled}
              atsApplicationFormFilterEnabled={
                props.atsApplicationFormFilterEnabled
              }
              atsInterviewContentFilterEnabled={
                props.atsInterviewContentFilterEnabled
              }
              atsJobStatusFilterEnabled={props.atsJobStatusFilterEnabled}
              filters={props.filterStates}
              filterTypes={props.filterTypes}
              onSearch={props.onSearch}
              setAlert={props.setAlert}
              setFilters={props.onFilterStatesUpdate}
              setFilterTypes={props.setFilterTypes}
            />
            <ListApplicationsTable
              atsSignableOfferEnabled={props.atsSignableOfferEnabled}
              candidates={props.candidates}
              currentUser={props.currentUser}
              emailAccountIntegration={props.emailAccountIntegration}
              error={props.error}
              hrisEmployees={props.hrisEmployees}
              hrisProvider={props.hrisProvider}
              filterStates={props.filterStates}
              totalFilteredCandidates={props.totalFilteredCandidates}
              selectedCandidates={props.selectedCandidates}
              offerRequisitionFlowEnabled={props.offerRequisitionFlowEnabled}
              isLoading={props.isLoading}
              onFilterStatesUpdate={props.onFilterStatesUpdate}
              reloadPage={props.reloadPage}
              setAlert={props.setAlert}
              setSelectedCandidates={props.setSelectedCandidates}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
